import { render, staticRenderFns } from "./SixBySix.vue?vue&type=template&id=d25bc9da&scoped=true"
import script from "./SixBySix.vue?vue&type=script&lang=js"
export * from "./SixBySix.vue?vue&type=script&lang=js"
import style0 from "./SixBySix.vue?vue&type=style&index=0&id=d25bc9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25bc9da",
  null
  
)

export default component.exports